import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { CHORD_PREFIX_KEY, CHORD_TIMEOUT_MS, GO_TO_ROUTES } from './useGoToShortcuts.constants';

const isTypingTarget = (target: EventTarget | null): boolean => {
	if (!(target instanceof HTMLElement)) return false;

	return target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName);
};

export const useGoToShortcuts = () => {
	const navigate = useNavigate();
	const pendingRef = useRef(false);
	const timerRef = useRef<ReturnType<typeof setTimeout>>();

	useEffect(() => {
		const handler = (e: KeyboardEvent) => {
			if (e.metaKey || e.ctrlKey || e.altKey || isTypingTarget(e.target)) return;

			const key = e.key.toLowerCase();

			if (key === CHORD_PREFIX_KEY) {
				pendingRef.current = true;
				clearTimeout(timerRef.current);
				timerRef.current = setTimeout(() => {
					pendingRef.current = false;
				}, CHORD_TIMEOUT_MS);
				return;
			}

			if (!pendingRef.current) return;

			pendingRef.current = false;
			clearTimeout(timerRef.current);
			const route = GO_TO_ROUTES[key];

			if (route) {
				e.preventDefault();
				navigate(route);
			}
		};

		window.addEventListener('keydown', handler);
		return () => {
			window.removeEventListener('keydown', handler);
			clearTimeout(timerRef.current);
		};
	}, [navigate]);
};
